import React from 'react';
import RoutePrivate from 'components/Route/Private/Private';
import { Route, Navigate, Routes } from 'react-router-dom';
import ScreensTaxonomyForm from './Form/ScreensTaxonomyForm';
import ScreensTaxonomyList from './List/ScreensTaxonomyList';
import ScreensTaxonomyLinked from './Linked/ScreensTaxonomyLinked';

function ScreensTaxonomy() {
  return (
    <Routes>
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensTaxonomyForm}
            requiredPermission="taxonomies.priviledgedCreate"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            element={ScreensTaxonomyForm}
            requiredPermission="taxonomies.priviledgedUpdate"
          />
        }
      />
      <Route
        path="/:id/linked"
        element={
          <RoutePrivate
            element={ScreensTaxonomyLinked}
            requiredPermission="taxonomies.priviledgedUpdate"
          />
        }
      />
      <Route
        path="/list"
        element={
          <RoutePrivate
            element={ScreensTaxonomyList}
            requiredPermission="taxonomies.priviledgedUpdate"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/taxonomies/list" />} />
    </Routes>
  );
}

export default ScreensTaxonomy;
